import JoinWaitlistModal from './JoinWaitlistModal';

export default JoinWaitlistModal;
